import { Navigate } from "react-router-dom";
import { useAppSelector } from "@store/hooks";
import MyNavbar from "@components/MyNavbar";

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const isAuthenticated = useAppSelector((state) => state.auth);
    
    return isAuthenticated ?
    <>
        <MyNavbar />
        {children}
    </>
    :
    <Navigate to="/" />;
};

export default ProtectedRoute;